import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../Global/Icon';

class Controls extends Component {
  renderSlidesNumbers(currentSlideIndex) {
    const { slidesCount, scrollToSlide } = this.props;
    const slidesNumbers = [];
    for (let i = 0; i < slidesCount; i++) {
      const buttonProps = {
        disabled: currentSlideIndex === i,
        key: i,
        onClick: () => scrollToSlide(i),
      };
      slidesNumbers.push(<button type="button" {...buttonProps}>{i + 1}</button>);
    }
    return slidesNumbers;
  }

  render() {
    const {
      getCurrentSlideIndex, slidesCount, style, className, arrowControl,
    } = this.props;
    const currentSlideIndex = getCurrentSlideIndex();
    let arrowEnable = false;
    if (arrowControl) {
      arrowEnable = true;
    }

    return (
      <div>
        <div className={className} style={style}>
          <button
            type="button"
            disabled={currentSlideIndex === 0}
            onClick={this.props.onPrev}
          >
            ←
          </button>
          {this.renderSlidesNumbers(currentSlideIndex)}
          <button
            type="button"
            disabled={currentSlideIndex === slidesCount - 1}
            onClick={this.props.onNext}
          >
            →
          </button>
        </div>
        {arrowEnable &&
          <div>
            <button
              type="button"
              onClick={this.props.onNext}
              className="recommendation-indicator"
            ><Icon icon='chevronDown' fill="red" />
            </button>
          </div>
        }
      </div>

    );
  }
}

export default Controls;

Controls.propTypes = {
  className: PropTypes.string,
  getCurrentSlideIndex: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrev: PropTypes.func.isRequired,
  scrollToSlide: PropTypes.func.isRequired,
  slidesCount: PropTypes.number.isRequired,
  style: PropTypes.object,
  arrowControl: PropTypes.object,
};

Controls.defaultProps = {
  className: 'full-page-controls',
  style: {},
  arrowControl: true,
};


// WEBPACK FOOTER //
// ./src/components/Fullpage/Controls.jsx